import axiosInstance from "./axiosInstance";

/**
 * Validates household ID
 * @param {string|number} householdId 
 * @returns {string|null} Error message or null if valid
 */
export const validateHouseholdId = (householdId) => {
  if (!householdId) return "Household ID is required";
  return null;
};

/**
 * Fetches the list of documents for a specific household.
 * @param {string|number} householdId 
 * @returns {Promise<Array>} List of documents
 */
export const fetchDocuments = async (householdId) => {
  const error = validateHouseholdId(householdId);
  if (error) throw new Error(error);

  try {
    const response = await axiosInstance.get(`/households/${householdId}/documents`);
    return response.data;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error.response?.data?.detail || "Failed to fetch documents";
  }
};

/**
 * Fetches a presigned URL for viewing a specific document.
 * @param {string|number} householdId 
 * @param {string|number} documentId 
 * @returns {Promise<string>} Presigned URL
 */
export const fetchDocumentUrl = async (householdId, documentId) => {
  const householdError = validateHouseholdId(householdId);
  if (householdError) throw new Error(householdError);

  if (!documentId) throw new Error("Document ID is required");

  try {
    const response = await axiosInstance.get(
      `/households/${householdId}/documents/${documentId}/presigned-url`
    );
    return response.data.presigned_url; 
  } catch (error) {
    console.error("Error fetching document URL:", error);
    throw error.response?.data?.detail || "Failed to fetch document URL";
  }
};
